module.exports = "/images/plus.svg";